<template>
    <div v-if="0 !== relations.length">
        <h2 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ title }}
        </h2>

        <member-relation-row
            v-for="relation in relations"
            :key="relation.id"
            :is-deletable="isDeletable"
            :member="relation.member"
            :pending-remove="pendingRemove"
            :legal-representatives="legalRepresentatives"
            :remove-button-label="$t('Familienbeziehung entfernen', {'fullName': fullName })"
            :legal-member="legalMember"
            @remove="$emit('remove', relation)"
            @addLegalRepresentative="$emit('addLegalRepresentative', relation.member)"
        />
    </div>
</template>

<script>
import MemberRelationRow from './MemberRelationRow';
import UrlMixin from './UrlMixin';

export default {
    name: 'KgrMemberRelationList',
    components: {
        MemberRelationRow,
    },
    mixins: [UrlMixin],
    props: {
        title: {
            type: String,
            required: true,
        },
        legalMember: {
            type: Object,
            required: true,
        },
        relations: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        legalRepresentatives: {
            type: Array,
            required: true,
        },
        pendingRemove: {
            type: Boolean,
            required: true,
            default: false,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        fullName() {
            if (!this.member) {
                return '';
            }
            let fullName = this.member.lastName;

            if (this.member.firstName) {
                fullName = this.member.firstName + ' ' + fullName;
            }

            return fullName;
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
